;(function (angular) {
  'use strict'

  angular
    .module('kilo.routes.bpu.list', [])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = ['$stateProvider']

  function RouteConfigurator ($stateProvider) {
    var listState = {
      name: 'bpu.list',
      url: '/list',
      // Retire le watcher $rootScope de la pagination résolue par cet état à sa sortie
      onExit: ['pagination', function (pagination) { pagination.destroy() }],
      resolve: {
        pagination: [ 'PaginationModel', function (PaginationModel) {
          return PaginationModel.get('bpuList')
        } ],
        customFields: ['CustomFieldManager', function (CustomFieldManager) {
          return CustomFieldManager.get(CustomFieldManager.query().select('bpu', 'model'))
            .then(function (data) {
              return data.data
            })
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/bpu/list/controllers/bpu-list.template.html',
          controller: 'BpuListController',
          controllerAs: 'list'
        },
        'toolbar@': {
          templateUrl: '/app/modules/bpu/list/controllers/bpu-list-toolbar.template.html',
          controller: 'BpuListToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: 'Liste des BPU',
        parent: ''
      }
    }

    $stateProvider
      .state(listState)
  }
})(window.angular)
